function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_124_3880)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 19C16.366 19 19.5 15.866 19.5 12C19.5 8.13401 16.366 5 12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19Z",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 23.4375C18.5406 23.4375 23.4375 18.5406 23.4375 12.5C23.4375 6.45939 18.5406 1.5625 12.5 1.5625C6.45939 1.5625 1.5625 6.45939 1.5625 12.5C1.5625 18.5406 6.45939 23.4375 12.5 23.4375Z",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 1.5625V4.6875",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.76575 4.76562L6.95325 6.95312",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5625 12.5H4.6875",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.76575 20.2344L6.95325 18.0469",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 23.4375V20.3125",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2345 20.2344L18.047 18.0469",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.4375 12.5H20.3125",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2345 4.76562L18.047 6.95312",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 8.59375L9.375 12.5L12.5 16.4062L15.625 12.5L12.5 8.59375Z",
  stroke: "currentColor",
  strokeWidth: 1.70455,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_124_3880"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "currentColor"
})));

const SvgCasino = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCasino, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/casino.e130d754.svg";
export { ForwardRef as ReactComponent };